/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview React-select style overrides for the participating company picker.
 * @module components/B2BEventParticipatingCompanyForm/companySelectStyles
 */

import { buildFullWidthSelectStyles } from "../../utils/reactSelectControlStyles.js";

/** Shared react-select theme for buyer company selection. */
export const companySelectStyles = buildFullWidthSelectStyles();
